import { useState } from 'react';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
function ObjectIdDelayButton() {
  const [loading, setLoading] = useState(false);
  return /*#__PURE__*/_jsx(UILoadingButton, {
    loading: loading,
    use: "primary",
    onClick: () => {
      setLoading(true);
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.modal.action.REQUEST"
    })
  });
}
export default ObjectIdDelayButton;